import { Component, Input } from '@angular/core';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { Navigator } from 'src/app/services/routing/navigator'
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-points-conversion',
  templateUrl: './points-conversion.page.html',
  styleUrls: ['./points-conversion.page.scss'],
})
export class PointsConversionPage {
  @Input() tab = 'currentState';
  
  public reward_States = {
    currentStatus: 'CURRENT_STATUS_WINDOW',
    requestConfirm: 'REQUEST_CONFIRM_WINDOW',
    feedBack: 'FEEDBACK_WINDOW'
  }
  public confirmationMsg = "";
  public isLoading: boolean = false;
  public points: number = 0;
  public userRate: number = 0;
  public minimumPoints: number = 0;
  private numberOfPoints: number = 0;
  public srcUrlEx: string = "";

  public currentState = this.reward_States.currentStatus;
  constructor(private rewardsService: RewardsService,
    public balanceProvider: AccountBalanceService, public navigator: Navigator, private config: ConfigService
  ) {
    this.initAllData();
    this.srcUrlEx = this.config.getConfig().FEATURE_HOW_IT_WORK_URL || "resorts-rewards-how-it-works";
  }

  onTabSelect(status) {
    this.tab = status
  }

  initAllData() {
    this.isLoading = true;
    this.rewardsService.callGetRewardExchangeRate().subscribe(
      (results) => {
        this.points = 0;
        this.handleRewardExchangeRate(results);
        this.stopLoader();
      },
      (error) => {
        //console.error("Error fetching data:", error);
        this.stopLoader();
      }
    );
  }

  private handleRewardExchangeRate(rewardExchangeRate: any) {
    if (rewardExchangeRate && rewardExchangeRate.payload) {
      this.userRate = rewardExchangeRate.payload.rate;
      this.minimumPoints = Number(rewardExchangeRate.payload?.minExchangeAmount) || 0;
    }
  }

  private convertPoints() {
    return new Promise((resolve, reject) => {
      this.rewardsService.callConvertRewardsPoints(this.points).subscribe((value) => {
        resolve(value);
      }, (error) => {
        reject(error)
      });
    })
  }

  pointsChange(points) {
    this.numberOfPoints = points;
  }

  redeemClicked(redeemObj) {
    this.currentState = this.reward_States.requestConfirm;
    this.points = this.numberOfPoints;
    const cash = redeemObj?.cashValue?.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) || '0.00';
  
    this.confirmationMsg = `Redeem ${this.points} points into $${cash} Cash.`;
  }

  onBack = () => {
    if (this.currentState == this.reward_States.requestConfirm || this.isShowError) {
      this.currentState = this.reward_States.currentStatus;
    } else {
      this.navigator.back();
    }
  }


  clickCancel() {
    this.currentState = this.reward_States.currentStatus;
  }

  isShowError: boolean = false;
  async clickContinue() {
    try {
      this.isLoading = true;
      await this.convertPoints();
      this.rewardsService.removeLoyaltyPoints();
      this.balanceProvider.updateBalance();
      this.stopLoader();
      this.isShowError = false;
      this.currentState = this.reward_States.feedBack;
    } catch (error) {
      this.stopLoader();
      this.isShowError = true;
      this.currentState = this.reward_States.feedBack;
    }
  }

  private stopLoader() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  clickCurrentStatus() {
    this.currentState = this.reward_States.currentStatus;
    this.initAllData();
  }

  onClickClose() {
    this.navigator.back();
  }
}
